// #/services/s3/listObjects.ts

import { AWS_S3_BUCKET } from '#/config/constants';
import { s3 } from '#/services/s3';

/**
 * Returns the list of strings corresponding to the keys of the objects in the
 * folder.
 *
 * @param args
 * @param args.folderKey The folder key to list objects from.
 * @returns
 */
export async function listObjects(args: {
  folderKey: string;
}): Promise<string[]> {
  try {
    const { folderKey } = args;

    const objects = await s3
      .listObjectsV2({
        Bucket: AWS_S3_BUCKET,
        Prefix: folderKey,
        Delimiter: '/',
      })
      .promise();

    const objectKeys: string[] = (objects.Contents ?? [])
      .filter(({ Key }) => Key !== '.file_placeholder')
      .reduce((ary, { Key }) => {
        return Key ? [...ary, Key] : ary;
      }, [] as string[]);

    return objectKeys;
  } catch (error: any) {
    console.error(`Error listing objects: ${error.message}`);
    // throw new Error(`Error listing objects: ${error.message}`);
    return [];
  }
}
export default listObjects;
